import { render, staticRenderFns } from "./solicitacaoIdenizatoriaDespacho.vue?vue&type=template&id=77c833c6&scoped=true&"
import script from "./solicitacaoIdenizatoriaDespacho.vue?vue&type=script&lang=js&"
export * from "./solicitacaoIdenizatoriaDespacho.vue?vue&type=script&lang=js&"
import style0 from "./solicitacaoIdenizatoriaDespacho.vue?vue&type=style&index=0&id=77c833c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c833c6",
  null
  
)

export default component.exports